import { render } from "./popup_searchDoctor.vue?vue&type=template&id=0b683b32"
import script from "./popup_searchDoctor.vue?vue&type=script&lang=js"
export * from "./popup_searchDoctor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__